import { COOKIES } from '@/services/constants';

import defaultUrls from './default.urls';

export default function ({ $cookies }, inject) {
  const getUrl = (page, queryParams = {}) => {
    const lang = $cookies.get(COOKIES.lang) || null;
    const urlsMap = defaultUrls;
    const urlBuilder = urlsMap[page];
    if (!urlBuilder) {
      throw new Error(`UrlBuilder error: Page ${page} does not exist`);
    }

    const path = urlBuilder({ lang, queryParams });
    const query = Object.entries(queryParams).map(
      ([queryParamName, queryParamValue]) => `${queryParamName}=${queryParamValue}`,
    );

    return query && query.length ? `${path}?${query.join('&')}` : path;
  };

  inject('getUrl', getUrl);
}
